<div class="row">
    <div class="col-12">
        <h2>Sorry, we couldn't find what you were looking for!</h2>
        <p>Please go back to the previous page and try again.</p>

        <p class="fw-bold">If the problem persists, please contact support.</p>
    </div>
</div>
